<template>
  <div v-if="modalOpen == true">
    <div class="fixed z-50 inset-0 overflow-y-auto">
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >

        <div
          class="fixed inset-0 transition-opacity"
          aria-hidden="true"
          @click="$emit('close')"
        >
          <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
          >&#8203;</span
        >

        <div
          class="bg-blue-100 inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
          style="width:800px"
        >
                <div class="flex flex-row-reverse">
                  <div @click="$emit('close')">
                    <svg-icon
                      icon="heroicons/solid/x"
                      class="mt-2 mr-2 opacity-50 hover:opacity-100 cursor-pointer h-8 w-8"
                    />
                  </div>
                </div>

            <slot name="body">

              <div class="flex flex-row-reverse pl-6 pr-2 pb-9">

                <div class="flex-none">
                  <img
                    :src="img"
                    class="w-96 mx-auto rounded-md border border-solid border-gray-300 shadow-md"
                  />
                </div>

                <div class="px-6 py-6 flex flex-col justify-end">

                  <div class="text-gray-700">
                  {{ text }}
                  </div>

                  <div class="flex flex-row mt-3">

                    <button
                      type="button"
                      style="border: 1px solid rgb(196 196 196);"
                      class="w-full inline-flex justify-center hover:no-underline rounded-md shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:w-auto sm:text-sm mr-3"
                      @click="preview(template)"
                    >
                    <span v-if="previewLoading" class="spinner mx-4" style="width:12px;height:12px"></span>
                    <span v-else class="">Preview</span>
                      
                    </button>

                    <button
                      type="button"
                      class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-purple-600 text-base font-medium text-white hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:w-auto sm:text-sm"
                      @click="use(template)"
                    >
                      
                    <span v-if="templateLoading" class="spinner-white mx-12" style="width:12px;height:12px"></span>
                    <span v-else class="">Use this template</span>
                    </button>

                  </div>
                </div>

              </div>
            </slot>

       
        </div>
      </div>
    </div>
  </div>
</template>

<script>

//import survey templates mixin
import { Templates } from "@/mixins/Templates";

export default {
  components: {  },
  name: "template-modal",
  mixins: [Templates],
  props: ["showModal", "template", "text", "img"],
  data: function() {
    return {
      previewLoading: false,
      templateLoading: false
    };
  },
  computed: {
    modalOpen() {
      return this.showModal;
    },
  },
  methods: {
    preview(template){
      this.previewLoading = true;
      this.previewTemplate(template);

    },
    use(template){
      this.templateLoading = true;
      this.useTemplate(template);

    }
  }

};
</script>
